import React, { useMemo } from 'react';
import { required } from '~/app/helpers/validation';
import Loader from '~/app/common/Loader';
import useForm, { UseFormOptionFields } from '~/app/modules/form/useForm';
import classes from './style.module.scss';
import useDidMountEffect from '~/app/hooks/useDidMountEffect';
import Details from './Details';
import Footer from './Footer';
import { TrainingApprovalPayload, TrainingDetail } from '~/training/types';

export type FormProps = {
  onClose(): void
  status: TrainingDetail['status']
}

export type FormComponent = React.FC<FormProps>

const Form: FormComponent = ({ onClose, status }) => {
  const formFields = useMemo(() => {
    const fields: UseFormOptionFields = [
      ['status', { validators: [['required', required]] }],
      ['comment', { validators: [['required', required]] }],
    ];

    return fields;
  }, []);

  const { values, removeForm } = useForm<TrainingApprovalPayload>({
    formName: 'approveTraining',
    fields: formFields,
    defaultValues: {
      status: status,
      comment: ''
    }
  });

  useDidMountEffect(() => (() => removeForm()));

  if (!values) {
    return <Loader size="32" />;
  }

  return (
    <>
      <div className={classes['container']}>
        <Details />
      </div>

      <Footer onClose={onClose} />
    </>
  );
};

export default Form;
